// validationMixin.js
export default {
  data() {
    return {
      fieldErrors: {}
    };
  },

  methods: {
    // Generic method for applying multiple rules
    validateFields(rules, item) {
      const errors = {};

      Object.keys(rules).forEach(field => {
        const fieldRules = rules[field];
        for (let i = 0; i < fieldRules.length; i++) {
          const { validate, message } = fieldRules[i];
          if (!validate.call(this, item[field])) {
            errors[field] = message;
            break; // Stop at first failed rule
          }
        }
      });

      this.fieldErrors = errors;
      return Object.keys(errors).length === 0;
    },

    // Helpers
    isValid(field) {
      return !this.fieldErrors[field];
    },

    invalidMessage(field) {
      return this.fieldErrors[field] || '';
    }
  }
};
